import {
    StyleSheet
} from "react-native";
import type {
    MarkdownDynamicStyles
} from "./type";

const stylesheet = StyleSheet.create({
    leftContainer: {
        justifyContent: "flex-start",
        alignItems: "flex-start",
        alignSelf: "flex-start"
    },
    blockquoteText: {
        textAlignVertical: "bottom",
        verticalAlign: "bottom"
    },
    rightContainer: {
        justifyContent: "flex-end",
        alignItems: "flex-end",
        alignSelf: "flex-end"
    },
    centerContainer: {
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center"
    },
    listContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    italic: {
        fontStyle: "italic"
    },
    bold: {
        fontWeight: "bold"
    },
    image: {
        maxWidth: "100%"
    },
    enter: {
        flexShrink: 1,
        width: "100%"
    },
    container: {
    }
});

export const useStyles = ({
    radiuses,
    colors,
    spaces
}: MarkdownDynamicStyles) => {
    const styles = {
        blockquoteContainer: {
            backgroundColor: colors.content.container.mid,
            borderRadius: radiuses.form,
            padding: spaces.spacingMd
        },
        blockquoteIcon: {
            marginBottom: spaces.spacingXs
        }
    };

    return styles;
};
export default stylesheet;
